import { ApiServiceBase, DEFAULT_API_OPTIONS } from "./apiServiceBase";
import { urls } from "../urls";

export class PayService extends ApiServiceBase {
  constructor({ baseUrl, timeout } = DEFAULT_API_OPTIONS) {
    super({ baseUrl, timeout });
    this._path = "Common";
  }

  getWechatJsSdkData(url) {
    return this._axios.get(`WeChat/JsSdkData?url=${url}`);
  }
  
  wechatLogin(code) {
    return this._axios.get(`WeChat/Login?code=${code}`);
  }

  getWechatLoginUrl(returnUrl) {
    const url = urls.loginWechat();
    return this._axios.get(`WeChat/GetCode?url=${url}&state=${returnUrl}&userInfo=true`);
  }

  getWechatAuthUrl(orderNo, chn) {
    // NOTE: 此 url 为用户授权后的回调地址!!!
    const url = urls.tenPay();
    const state = `${chn},${orderNo}`;
    return this._axios.get(`WeChat/GetCode?url=${url}&state=${state}`);
  }

  wechatPay(orderNo, code) {
    const url = urls.tenPay();
    return this._axios.get(`Wechat/Pay?orderNo=${orderNo}&code=${code}&url=${url}`);
  }
  
  alipay(orderNo) {
    const url = urls.payResult(orderNo);
    return this._axios.get(`Alipay/Pay?orderNo=${orderNo}&businessUrl=${url}`);
  }

  wechatPayNSPOS(orderNo, code) {
    // NOTE: 此 url 为 JSSDK 验证地址!!!
    const url = urls.tenPay();
    return this._axios.get(`NSPOS/WechatPay?orderNo=${orderNo}&code=${code}&url=${url}`);
  }
  
  alipayNSPOS(orderNo) {
    return this._axios.get(`NSPOS/Alipay?orderNo=${orderNo}`);
  }
  
  b2bNSPOS(orderNo, bankId) {
    const url = urls.payResult(orderNo);
    return this._axios.get(`NSPOS/B2B?orderNo=${orderNo}&bankId=${bankId}&businessUrl=${url}`);
  }
  
  getBanksOfB2BNSPOS() {
    return this._axios.get("NSPOS/GetBank");
  }
}

export const payService = new PayService();
